import { ListLayout } from 'components/common/ListLayout'
import CustomWorkOrderModal from 'components/appointment/CustomWorkOrderModel';
import React, { useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppointmentView } from 'slices/inviteInterpreterSlice';
import { assignInterpreter } from 'slices/inviteInterpreterSlice';
import { fetchInvitedInterpreters } from 'slices/inviteInterpreterSlice';
import { inviteInterpretersSelector } from 'slices/inviteInterpreterSlice';
import { removeInvitedInterpreters } from 'slices/inviteInterpreterSlice';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import FullPageLoader from 'components/common/FullPageLoader';

const getBackgroundStyle = (status) => {
  
};

const AppointedInterpretersList = ({ itemId, fetchAppointment, height }) => {
  const dispatch = useDispatch()
  const { last_page: totalPages, loader, invitedInterpreters } = useSelector(inviteInterpretersSelector);
  const appointment = invitedInterpreters?.invites
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });

  const [loading, setLoading] = useState(false);
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);

  const fetchData = async () => {
    dispatch(fetchInvitedInterpreters(itemId))
  };

  React.useEffect(() => {
    fetchData();
  }, [itemId]);


  const handleAddInviteInterpreterPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleSubmitInviteInterpreters = React.useCallback(() => {

    const submitCallback = (status, message) => {
      if (status) {
        toast.success(message, {
          className: "successToast",
        })
        setSelectedItems([]);
        setSelectAll(false)
         dispatch(fetchInvitedInterpreters(itemId))
        dispatch(fetchAppointmentView(itemId))
        
        hideConfirmDialog()
      }
      else {
        toast.error(message,
          {
            className: "errorToast",
          }
        );
      }
    };
    new Swal({
      title: "Are you sure?",
      text: "You want to Remove them?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!"
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(removeInvitedInterpreters({ interpreter_ids: selectedItems, }, itemId, submitCallback))
      }
    })
  }, [selectedItems])

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = React.useCallback(() => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(appointment.map((inviteInterpreter) => inviteInterpreter.id.toString()))
  }, [selectedItems, selectAll, appointment])



  const renderTableHeader = React.useCallback(() => {

    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                checked={selectAll}
                onChange={handleToggleSelectAll}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </th>
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Code</p>
          </div>
        </th>
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Name</p>
          </div>
        </th>
        <th className="col-2">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Email</p>
          </div>
        </th>
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Phone</p>
          </div>
        </th>
        <th className="col-2">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Languages</p>
          </div>
        </th>
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Status</p>
          </div>
        </th>
        <th className="col-2">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Work Order Status</p>
          </div>
        </th>
        <th className="col-1">
          {" "}
          <div>
            <p>Actions</p>
          </div>
        </th>
      </tr>
    );
  }, [selectedItems, appointment])

  const renderTableContent = React.useCallback(() => {
    return (
      appointment?.map((item, index) => {
        return <AppointedIntepreterItem itemId={itemId} item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteInterpreterPopUp} setLoading={setLoading}/>
      })
    )
  }, [appointment, selectedItems, itemId]);

  // const renderTableContent = React.useCallback(() => {
  //   if (!appointment || appointment.length === 0) {
  //     // ✅ Dummy data
  //     const dummy = [
  //       {
  //         id: "dummy1",
  //         code: "INT-001",
  //         first_name: "John",
  //         last_name: "Doe",
  //         email: "john.doe@example.com",
  //         phone: "+1-555-123456",
  //         languages: [{ language: { name: "Spanish" } }],
  //       },
  //       {
  //         id: "dummy2",
  //         code: "INT-002",
  //         first_name: "Jane",
  //         last_name: "Smith",
  //         email: "jane.smith@example.com",
  //         phone: "+1-555-654321",
  //         languages: [{ language: { name: "French" } }],
  //       },
  //     ];

  //     return dummy.map((item, index) => (
  //       <AppointedIntepreterItem
  //         item={item}
  //         index={index}
  //         selectedItems={selectedItems}
  //         handleChange={handleChange}
  //         handleAddPopUp={handleAddInviteInterpreterPopUp}
  //       />
  //     ));
  //   }

  //   return appointment.map((item, index) => (
  //     <AppointedIntepreterItem
  //       item={item?.interpreter}
  //       index={index}
  //       selectedItems={selectedItems}
  //       handleChange={handleChange}
  //       handleAddPopUp={handleAddInviteInterpreterPopUp}
  //     />
  //   ));
  // }, [appointment, selectedItems]);


  const handleClose = React.useCallback(() => {
    refAddutton.current.click();
    setAddForm({ show: false })
  }, [])


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const renderFooter = React.useCallback(() => {
    return (
      <div className="row-primary">

        <button
          onClick={handleSubmitInviteInterpreters}
          disabled={selectedItems?.length == 0}
          className="main_button"
          style={{

            // float: "right",
            marginRight: 20
          }}
        >
          Remove Interpreters
        </button>
      </div>
    )
  }, [selectedItems])
  return (
    <>
      <ListLayout
        title="Invited Interpreters - Email"
        addButtonDisabled={true}
        buttonTitle="Add InviteInterpreter"

        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        fetchList={fetchData}
        height={height}
        selectedItems={selectedItems}
        // handleRemoveItems={handleRemoveItems}
        // renderAddForm={<AddInviteInterpreter item={addForm.item} show={addForm.show} onClose={handleClose} />}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddInviteInterpreterPopUp}
        renderFooter={renderFooter}
        hideRemoveButton={true}
        // loader={loader}
        hidePageLength={true}
        hidePagination={true}
        hideSearchBar={true}
        showRemoveOnTop={true}
        containerStyle={{
          marginTop: 20
        }}
        time={false}

      >


        {/* {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />} */}

        {/* <AddInviteInterpreter item={addForm.item} show={addForm.show} refAddutton={refAddutton} onClose={handleClose} /> */}
      </ListLayout>
      {loading && <FullPageLoader />}
      {/* Create full page Loader */}

    </>
  )

};

const AppointedIntepreterItem = ({
  item,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  itemId,
  setLoading
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [customPricingModal, setCustomPricingModal] = useState({
    show: false,
    interpreter: null,
  });

  const handleAssignInterpreter = (item) => {
    const interpreterId = item?.interpreter?.id;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to assign this interpreter?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Assign",
      confirmButtonColor: "#096171",
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        dispatch(assignInterpreter(
        {
          appointment_id: itemId,
          interpreter_id: interpreterId,
        },
          (status, message) => {
            setLoading(false);
            if (status) {
            toast.success(message);
            navigate(`/appointments/view/${itemId}`);
          } else {
            toast.error(message);
          }
        }
      ));
      }
    });
  };

  
  const formatDateTime = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);

      const month = date.getMonth() + 1;
      const day = date.getDate();
      const year = date.getFullYear();

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${month}/${day}/${year} ${hours}:${minutes}`;
  };
  return (
    <>
      <CustomWorkOrderModal
        item={{ ...customPricingModal.item?.interpreter, appt_id: itemId }}
        show={customPricingModal.show}
        onClose={() => setCustomPricingModal({ show: false, item: null })}
        popupType="custom"
      />

      <tr>

        <td style={getBackgroundStyle(item?.status)}>
          <div className="row_check">
            <span>{index + 1}</span>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={item?.interpreter?.id}
                checked={selectedItems.includes(item?.interpreter?.id?.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </td>

        <td style={getBackgroundStyle(item?.status)}>
          <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.interpreter?.id}`}>
            {item?.interpreter?.code}
          </a></td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.first_name + " " + item?.interpreter?.last_name}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.user?.email}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.phone}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.languages?.map((l) => l?.language?.name + ", ")}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.status} {item?.status === 'accepted' && (<span style={{ fontSize:'11px', marginTop:'5px', display: 'inline-block' }}>{formatDateTime(item?.updated_at)}</span>)}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.work_order_status}</td>

          <td style={getBackgroundStyle(item?.status)} className='d-flex gap-2'>
            {item?.work_order_status !== "pending" &&
            <button
              className="main_button"
              onClick={() => setCustomPricingModal({ show: true, item })}
            >
              Custom Work Order
            </button>
        }
        {item?.status == "accepted" && 
            <button
              className="main_button green"
              onClick={() => handleAssignInterpreter(item)}
            >
              Assign
            </button>
          
        }
          </td>
      </tr>
    </>
  );
};


export default AppointedInterpretersList